import { useContext } from "react";

import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import update from "@beeldit/core/services/update";
import { EditAssignationActionContext } from "./EditAssignationActionContext";

function useUpdate() {
  const { element, setBackendFormErrors } = useContext(EditAssignationActionContext);
  const errorHandler = useErrorHandler();

  return (assignmentId: number, onSuccess: any) => {
    update(`assignments/${assignmentId}/assignation`, element.assignation_id, element)
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useUpdate;
